import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: { name: "auth" },
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/Auth/index.vue"),
    redirect: {
      name: "login",
    },
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("@/views/Auth/Login.vue"),
      },
      {
        path: "init-pswd",
        name: "initUserPassword",
        component: () => import("@/views/Auth/InitPassword.vue"),
      },
      {
        path: "init-phone",
        name: "initUserPhoneNumber",
        component: () => import("@/views/Auth/InitPhoneNumber.vue"),
      },
      {
        path: "profile",
        name: "userProfile",
        component: () => import("@/views/Auth/Profile.vue"),
      },
    ],
  },

  {
    path: "/_guide",
    name: "guide",
    component: () => import("@/views/Guide/index.vue"),
  },

  {
    path: "/tlqnad",
    name: "admin_page",
    component: () => import("@/views/Admin/index.vue"),
    redirect: {
      name: "sample_distribution",
    },
    children: [
      // {
      //   path: "index",
      //   name: "admin_index",
      //   component: () => import("@/views/Admin/Index/index.vue"),
      // },
      {
        path: "user-group",
        name: "admin_user_group",
        component: () => import("@/views/Admin/UserGroup/index.vue"),
      },
      {
        path: "sample-group",
        name: "admin_sample_group",
        component: () => import("@/views/Admin/SampleGroup/index.vue"),
      },
      {
        path: "quality",
        name: "admin_quality",
        component: () => import("@/views/Admin/Quality/index.vue"),
      },

      {
        path: "sample-distribution",
        name: "sample_distribution",
        component: () => import("@/views/Admin/SampleDistribution/index.vue"),
      },
      {
        path: "feedback",
        name: "feedback",
        component: () => import("@/views/Admin/Feedback/index.vue"),
      },
    ],
  },

  // 组长页面路由 --------------------------------------------
  {
    path: "/tlqnlder",
    name: "leader_page",
    component: () => import("@/views/Leader/index.vue"),
  },

  // 调查系统的路由 -----------------------------------------
  {
    path: "/tlqnmbr",
    name: "member_page",
    component: () => import("@/views/Member/index.vue"),
    redirect: {
      name: "member-index",
    },
    children: [
      {
        name: "member-index",
        path: "index",
        component: () => import("@/views/Member/Home/index.vue"),
      },
      {
        name: "member-sample-detail",
        path: "sample/:sample_id",
        component: () => import("@/views/Member/SampleDetail/index.vue"),
      },
      {
        name: "member-sample-check",
        path: "checksample/:sample_id",
        component: () => import("@/views/Member/SampleCheck/index.vue"),
      },
      {
        name: "member-questionnaire",
        path: "questionnaire/:sample_id",
        component: () => import("@/views/Member/Questionnaire/index.vue"),
      },
    ],
  },

  {
    path: "/tlqntelephoneinterv",
    name: "telep_intv",
    component: () => import("@/views/TelpIntv/index.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
